export const getHeaders = () => {
  return {
    companyNo: ~~sessionStorage.getItem("companyNo"),
    ...(sessionStorage.getItem("token") && {
      jwtToken: sessionStorage.getItem("token"),
    }),
    "Cache-Control": "private",
    "Content-Type": "application/json; charset=utf-8",
    "Cache-Control": "no-store",
    "Referrer-Policy": "no-referrer",
    "X-Frame-Options": "Deny",
    "X-XSS-Protection": 1,
    mode: "block",
  };
};

export const forceNavigate = (endPoint) => {
  return window.location.replace(endPoint);
};
